import { useSyncExternalStore } from 'react';

// Qualité du réseau : Network Information API (Android) + latence réelle des appels API.
// weak = true → les rafraîchissements non essentiels (météo, radar, relief…) sont mis en pause.
const conn = typeof navigator !== 'undefined' ? (navigator.connection || navigator.mozConnection || navigator.webkitConnection) : null;
const listeners = new Set();
let slowAt = [];
let state = { online: typeof navigator === 'undefined' || navigator.onLine !== false, weak: false, reason: null };

const evaluate = () => {
  const online = typeof navigator === 'undefined' || navigator.onLine !== false;
  let weak = false; let reason = null; let hint = null;
  if (conn) {
    const et = conn.effectiveType;
    if (et === 'slow-2g' || et === '2g') { weak = true; reason = '2G'; }
    // L'API réseau d'Android sous-estime souvent le débit (ex. LTE+ 4 barres annoncé « 0,6 Mb/s ») :
    // 3G / latence / débit ne sont qu'un INDICE, confirmé seulement par une vraie réponse lente.
    else if (et === '3g') hint = '3G';
    else if (typeof conn.rtt === 'number' && conn.rtt >= 700) hint = 'latence élevée';
    else if (typeof conn.downlink === 'number' && conn.downlink > 0 && conn.downlink < 0.7) hint = 'débit faible';
  }
  const now = Date.now();
  slowAt = slowAt.filter((t) => now - t < 60000);
  if (!weak && hint && slowAt.length >= 1) { weak = true; reason = hint; }
  if (!weak && slowAt.length >= 2) { weak = true; reason = 'réponses lentes'; }
  if (state.online !== online || state.weak !== weak || state.reason !== reason) {
    state = { online, weak, reason };
    listeners.forEach((l) => l());
  }
};

// Seuls les appels « rapides » servent d'échantillon (les analyses IA durent légitimement 10-60 s).
const FAST_API_PREFIXES = ['/weather', '/spots', '/auth', '/wms', '/territories', '/promo', '/groups', '/notifications', '/lots', '/hunt-plan/'];
export const isLatencySample = (url = '') => {
  const path = url.replace(/^https?:\/\/[^/]+/, '').replace(/^\/api/, '');
  return FAST_API_PREFIXES.some((p) => path.startsWith(p)) && !/\/(generate|analyze|analysis)/.test(path);
};

// Appelé par l'intercepteur API : échec réseau / délai ou réponse > 5 s = échantillon lent.
export const reportLatency = (ms, failed = false) => {
  if (failed || ms > 5000) slowAt.push(Date.now());
  else if (ms < 1500 && slowAt.length) slowAt = [];
  evaluate();
};

export const isWeakSignal = () => state.weak || !state.online;
export const getNetworkQuality = () => state;

if (typeof window !== 'undefined') {
  window.addEventListener('online', evaluate);
  window.addEventListener('offline', evaluate);
  conn?.addEventListener?.('change', evaluate);
  setInterval(evaluate, 15000);
  evaluate();
}

const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };
export const useNetworkQuality = () => useSyncExternalStore(subscribe, getNetworkQuality, getNetworkQuality);
